export default __webpack_public_path__ + "static/media/FSDC.870043a0.jpg";